module.exports = "/public/images/9ad610c51ebe80c1917e43fe297623b2.png";